<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';
import { type HeaderWithChildren, getHeaders } from '~/composables/outline';
import TocOutlineList from '~/views/docs/components/TocOutlineList.vue';

const headers = ref<HeaderWithChildren[]>([]);
const container = ref();
const marker = ref();

onMounted(() => {
  nextTick(() => {
    headers.value = getHeaders();
  });
});
</script>

<template>
  <div v-show="headers.length" ref="container">
    <!-- Desktop view -->
    <div class="hidden lg:block">
      <div
        ref="marker"
        class="absolute -left-3 top-7 h-5 w-[3px] bg-new-green-700 opacity-0 transition-[top]"
      />

      <div class="mb-1 hidden font-semibold sm:block">On this page</div>
      <TocOutlineList
        v-if="headers.length && container"
        :headers="headers"
        :container="container"
        :marker="marker"
      />
    </div>

    <!-- Mobile view -->
    <details class="lg:hidden">
      <summary class="mb-1 cursor-pointer text-sm font-semibold">On this page</summary>

      <div class="pl-4">
        <TocOutlineList
          v-if="headers.length && container"
          :headers="headers"
          :container="container"
          :marker="marker"
        />
      </div>
    </details>
  </div>
</template>
